export enum BroadcastChannelNames {
  RelativityAuth = 'relativity-oauth',
}

export enum RelativityAuthMessageTypes {
  Success = 'relativity-auth-success',
  Error = 'relativity-auth-error',
  Connected = 'relativity-auth-connected',
}

export interface BroadcastMessage {
  timestamp: number;
}

export interface RelativityAuthMessage extends BroadcastMessage {
  type: RelativityAuthMessageTypes;
  sessionKey: string | null;
}

// The popup received an authorisation code. The flow is not connected until the opener that
// started it posts the code to /oauth/relativity/complete.
export interface RelativityAuthSuccessMessage extends RelativityAuthMessage {
  type: RelativityAuthMessageTypes.Success;
  code: string;
}

export interface RelativityAuthErrorMessage extends RelativityAuthMessage {
  type: RelativityAuthMessageTypes.Error;
  error: string | null;
  description: string | null;
}

// Sent by the instance that completed the flow so every other instance re-checks the server's
// connection status. Carries no code and is never trusted as proof of connection on its own.
export interface RelativityAuthConnectedMessage extends RelativityAuthMessage {
  type: RelativityAuthMessageTypes.Connected;
}

export type RelativityAuthMessages =
  | RelativityAuthSuccessMessage
  | RelativityAuthErrorMessage
  | RelativityAuthConnectedMessage;
